import { useEffect } from 'react';

/**
 * Hook to synchronize pagination state with filter changes
 * Resets pagination to page 1 when filters change
 */
export const useFilterPaginationSync = ({
  filterValues,
  setPagination,
  rowsCount,
  currentPageSize,
}: {
  filterValues: unknown[] | undefined;
  setPagination: (pagination: { page: number; pageSize: number }) => void;
  rowsCount?: number;
  currentPageSize?: number;
}) => {
  useEffect(() => {
    setPagination({
      page: 1,
      pageSize: currentPageSize ?? rowsCount ?? 10,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValues]);
};
